<div
  class="d-flex align-items-center w-100 py-0 list-group-item list-group-item-hover multiple-suggester-nested-item-row"
  [style]="indentationStyle()"
  [class.active]="isChecked || isIndeterminate"
  [class.disabled]="isDisabled"
>
  @if (hasChildren) {
  <i
    class="cursor-pointer f-i f-i-sm"
    [class.f-i-chevron-down]="isExpanded"
    [class.f-i-chevron-right]="!isExpanded"
    (click)="onToggleExpand($event)"
  ></i>
  } @if (!hasChildren) {
  <span class="me-5"></span>
  }
  <f-list-item-checkbox
    fDropdownItem
    [tabable]="false"
    [hasSelectedStyles]="true"
    [checkOnEnter]="false"
    [hoverable]="false"
    [itemCheckboxClass]="'px-2'"
    [checked]="isChecked"
    [indeterminate]="isIndeterminate"
    [disabled]="isDisabled"
    [title]="disabledTooltip"
    (keydown.enter)="onEnterKey($event)"
    (toggle)="onCheckboxChange($event)"
    class="flex-grow-1"
  >
    <f-suggester-list-item
      [item]="item()"
      [linkPath]="linkPath()"
      [valuePath]="valuePath()"
      [suggesterItemTemplate]="suggesterItemTemplate()"
      [inputValue]="inputValue()"
      [highlightTreatAsPhrase]="true"
      class="text-truncate flex-grow-1"
    >
    </f-suggester-list-item>
  </f-list-item-checkbox>
</div>

@if (hasChildren && isExpanded) { @for (child of children; track child) {
<f-multiple-suggester-nested-item
  [item]="child"
  [level]="level() + 1"
  [maxLevel]="maxLevel()"
  [childrenPath]="childrenPath()"
  [idField]="idField()"
  [valuePath]="valuePath()"
  [linkPath]="linkPath()"
  [itemCssClass]="itemCssClass()"
  [disabledPath]="disabledPath()"
  [expandedItems]="expandedItems()"
  [suggesterItemTemplate]="suggesterItemTemplate()"
  [inputValue]="inputValue()"
  [nestedValuePipe]="nestedValuePipe()"
  [parentComponent]="parentComponent()"
  (toggleExpand)="toggleExpand.emit($event)"
  (checkboxChange)="checkboxChange.emit($event)"
  (itemClick)="itemClick.emit($event)"
  (enterKey)="enterKey.emit($event)"
>
</f-multiple-suggester-nested-item>
} }
